module.exports = __webpack_public_path__ + "img/logobig.5451b9b6.png";